var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zj-moble-app-page"},[_vm._v(" "+_vm._s(_vm.Msg)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }